const ActionsMap = {
  SET_HEADER_TITLE: 'SET_HEADER_TITLE',
};

export default ActionsMap;
